/**
 * Sorrel House · footer : accordeons mobiles (Shop, Help, House) et revelation du logo geant.
 * <sh-foot-mark> passe en .is-in a l'entree dans l'ecran (IntersectionObserver, seuil 15 %),
 * avec repli si l'observateur manque. Sous prefers-reduced-motion, le CSS affiche tout d'emblee.
 */
document.addEventListener('click', (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-sh-foot-toggle]') : null;
  if (!btn) return;
  const list = document.getElementById(btn.getAttribute('aria-controls') || '');
  if (!list) return;
  const open = btn.getAttribute('aria-expanded') !== 'true';
  btn.setAttribute('aria-expanded', String(open));
  list.classList.toggle('is-open', open);
  const sign = btn.querySelector('.sh-foot__sign');
  if (sign) sign.textContent = open ? '–' : '+';
});

class ShFootMark extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
    this.io = new IntersectionObserver((entries) => {
      if (entries.some((en) => en.isIntersecting)) { this.classList.add('is-in'); this.io.disconnect(); }
    }, { threshold: 0.15 });
    this.io.observe(this);
  }
  disconnectedCallback() { this.io?.disconnect(); }
}
if (!customElements.get('sh-foot-mark')) customElements.define('sh-foot-mark', ShFootMark);
